
import React from "react";
import { Helmet } from "react-helmet-async";
import TopNavbar from "@/components/layout/TopNavbar";
import Footer from "@/components/home/Footer";

const AboutUs = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>Our Why - Hivetivity</title>
        <meta name="description" content="Learn about Hivetivity's mission to empower youth program management" />
      </Helmet>
      
      <TopNavbar />
      
      <main className="pt-16">
        <div className="container mx-auto px-4 py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-4xl font-bold text-[#5a5a59] mb-8">About Hivetivity</h1>
            
            <div className="prose prose-lg">
              <p className="text-gray-600 mb-6">
                At Hivetivity, we're passionate about empowering youth program leaders to create 
                exceptional experiences for children and families. Our platform simplifies program 
                management, allowing you to focus on what matters most - inspiring young minds.
              </p>
              
              <div className="my-12 rounded-xl overflow-hidden">
                <img 
                  src="https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d" 
                  alt="Team collaboration" 
                  className="w-full h-[400px] object-cover"
                />
              </div>
              
              <h2 className="text-2xl font-semibold text-[#5a5a59] mb-4">Our Mission</h2>
              <p className="text-gray-600 mb-6">
                We believe that every child deserves access to enriching programs that foster growth, 
                creativity, and learning. By providing powerful, yet intuitive tools, we help program 
                directors streamline their operations and create more meaningful experiences.
              </p>
              
              <h2 className="text-2xl font-semibold text-[#5a5a59] mb-4">Our Values</h2>
              <ul className="list-disc pl-6 text-gray-600 mb-6">
                <li className="mb-2">Excellence in everything we do</li>
                <li className="mb-2">Commitment to youth development</li>
                <li className="mb-2">Innovation in program management</li>
                <li className="mb-2">Support for program leaders</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default AboutUs;
//comments